import { protectedRoute } from "@/lib/protectedRoute";
import { Visits } from "@/pages/Visits";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/visits/")({
  component: Visits,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
  validateSearch: z.object({
    openNewVisit: z.coerce.boolean().optional(),
  }),
});
